import * as bootstrap from 'bootstrap';
import '@popperjs/core';

window.bootstrap = bootstrap;

import './home-swiper';
import './trust-us-swiper';
import './contact-map';
import './component-big-slider';
import './production-swiper';
import './newsletter-freshmail';
import './cookies-popup';
import './amount';
import './select2-init'
import './quantity-buttons'
import './quotation-anim'
import './checkmac'
import './woocommerce'
import './woocommerce-variations'
import './woocommerce-wishlist'
import './dropdown'
import './newsletter-popup'
import './workshop'
import './checkout-continue-as-guest'
